module.exports = __webpack_public_path__ + "img/complete.ea1f7f13.png";